'use client';

import React, { PropsWithChildren } from 'react';
import {
  UnauthenticatedLayout,
  UnauthenticatedLayoutProps
} from '@ianesthesie-kit/common-pages';
import { ResponsiveBox } from '@/components/responsiveBox';
import { styled } from '@mui/material';
import AuthPageIllustration from '../../../public/LandingAnimationManHoopcare.gif';
import { CenteredContainer } from '@ianesthesie-kit/core';

const ImageContainer = styled('div')`
  width: 100%;
  height: 100%;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
`;

export const Container = styled('div')`
  main > div:first-of-type {
    display: flex;
    align-items: center;
    background-color: #f5f7fa;
  }

  @media (max-width: 1500px) {
    main > div:last-of-type > div {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
`;

const InnerWrapper = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const AuthPageIllustratedLayout = ({
  children,
  ...props
}: PropsWithChildren<UnauthenticatedLayoutProps>) => (
  <Container>
    <UnauthenticatedLayout
      langSelectorContainerProps={{
        sx: {
          position: 'absolute',
          width: '100%',
          zIndex: 2,
          transform: 'scale(0.8)',
          mr: 0,
          '& button': {
            p: 0,
            fontSize: '1.7rem',
            lineHeight: '1.8rem'
          }
        }
      }}
      imgSrc={AuthPageIllustration}
      imgProps={{
        priority: true,
        unoptimized: true,
        loading: 'eager',
        placeholder: 'blur',
        blurDataURL: '../../../LandingAnimationManHoopcare_placeholder.gif',
        alt: 'Auth page decorative illustration',
        style: { objectPosition: 'center', objectFit: 'contain' }
      }}
      imageContainer={({ children: image, ...p }) => (
        <ResponsiveBox
          hiddenDown="sm"
          sx={{
            display: 'flex',
            position: 'relative',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            height: '100%',
            width: {
              xs: '70%',
              lg: '50%'
            }
          }}
          {...p}
        >
          <ImageContainer sx={{ overflowY: 'hidden', mx: 'auto' }}>
            {image}
          </ImageContainer>
        </ResponsiveBox>
      )}
      {...props}
    >
      <InnerWrapper>
        <CenteredContainer flexGrow={1}>{children}</CenteredContainer>
      </InnerWrapper>
    </UnauthenticatedLayout>
  </Container>
);
